import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss'],
})
export class UploadProgressComponent implements OnInit {
  @Input() fileService: any;
  @Input() serverUrl: any;
  @Input() containerName: 'LOGO' | 'MAIN_BANNER' | 'GALLERY';
  @Input() images: string[];
  @Input() imageindex: number;
  @Input() uploaderOptions: any;

  progressList = [];
  uploadStatus: { [key: number]: { status: 'success' | 'error'; data: any } } =
    {};

  response: {
    status: 'success' | 'error';
    uploadStatus?: {
      [key: number]: { status: 'success' | 'error'; data: any };
    };
  };

  constructor(
    private popoverCtrl: PopoverController,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {}

  ionViewDidEnter() {
    let myContainername = this.containerName.toLocaleLowerCase();

    if (this.containerName === 'MAIN_BANNER') {
      myContainername = 'about';
    }

    const promises = [];

    this.images = this.images || [];
    this.imageindex = this.imageindex !== undefined ? this.imageindex : 0;

    this.images.forEach((imgUri, idx) => {
      promises[idx] = this.fileService
        .uploadFile(
          imgUri,
          this.serverUrl,
          // onProgress
          (progressEv) => {
            this.progressList[idx] = progressEv.loaded / progressEv.total;
            this.cdr.detectChanges();
          },
          // uploader options
          {
            fileName: `business.${myContainername}_${idx}.jpg`,
            fileKey: 'img',
            ...this.uploaderOptions,
          }
        )
        // on success
        .then(
          (resp: any) => {
            this.progressList[idx] = 1;
            this.uploadStatus[idx] = { status: 'success', data: resp.data };
            this.cdr.detectChanges();
            return resp;
          },
          (error) => {
            let errors = ['An unknown error ocurred!'];

            if (error.body) {
              try {
                errors = JSON.parse(error.body);
                console.error('*** uploadImages ERROR:', errors);
                errors = (errors as any).message || (errors as any).data.msg;
              } catch (e) {}
            } else {
              console.error('******=> uploadImages ERROR:', error);
              errors = (errors as any).message || (errors as any).msg;
            }

            this.uploadStatus[idx] = { status: 'error', data: errors };

            this.cdr.detectChanges();

            return false;
          }
        );
    });

    Promise.all(promises).then(
      (resp: Array<{ status: 'success' | 'error'; data: any }>) => {
        const hasErrors = resp.some(
          (uploaded) => uploaded.status !== 'success'
        );

        this.response = {
          status: hasErrors ? 'error' : 'success',
          uploadStatus: this.uploadStatus,
        };

        this.popoverCtrl.dismiss(this.response);
      },
      (error) => {
        console.error('Promise.all(promises)', error);
      }
    );
  }
}
